import { ForwardedRef, forwardRef } from 'react'

import classNames from 'classnames'

import { CommonSmallVerticalArrowBoldIcon } from '@local/assets/icons'

import { ClickEvent } from '@web/types'
import { useClickableContext } from '@web/ui/components/Clickable/context'
import { BookingPrimitive } from '@web/ui/pages/home/components/Sections/UIDailyBriefingSection/DailyBriefingSection.type'

import ListFilterButtonWrapper from './ListFilterButtonWrapper'
import styles from './ListFilterWhiteButton.module.scss'

interface Props {
  name: React.ReactNode
  count?: number
  selected?: boolean
  showArrow?: boolean
  hasPopup?: boolean
  expanded?: boolean
  typeMulti?: boolean
  wrapperClassName?: string
  anchorClassName?: string
  selectedBooking?: BookingPrimitive
  clickCode?: string
  onClick?: (e: ClickEvent) => void
}
function ListFilterWhiteButton(props: Props, ref?: ForwardedRef<HTMLSpanElement>) {
  const {
    name,
    count,
    selected,
    showArrow,
    hasPopup,
    expanded,
    typeMulti,
    wrapperClassName,
    anchorClassName,
    clickCode,
    onClick,
  } = props
  const Clickable = useClickableContext()

  return (
    <ListFilterButtonWrapper wrapperRef={ref} wrapperClassName={wrapperClassName}>
      <Clickable
        className={classNames(styles.btn, { [styles.type_multi]: typeMulti }, anchorClassName)}
        aria-pressed={selected}
        aria-expanded={expanded}
        aria-haspopup={hasPopup}
        onClick={onClick}
        nClickCode={clickCode}
      >
        {name}
        {count && <em className={styles.count}>{count}</em>}
        {showArrow && <CommonSmallVerticalArrowBoldIcon className={styles.icon_arrow} />}
      </Clickable>
    </ListFilterButtonWrapper>
  )
}

export default forwardRef(ListFilterWhiteButton)
